export default __webpack_public_path__ + "img/bg-out.jpg?1859";